<template>
  <div class="form-condition" :rel="name" v-bind:class="{'form-required': required, 'form-disabled':disabled}">
    <div class="form-label">
      <label>{{ label }}</label>
    </div>
    <div class="form-hint" v-show="hint">{{ hint }}</div>
    <div class="form-input">

      <div class="form-input-wrapper">

        <div v-for="item in options" class="form-condition-label">
          <label>
            <input type="radio" v-model="inputValue" :id="item.id" :value="item.id" :disabled="disabled"/>
            <span>
                <span class="checkbox"><i class="icon icon-icon_check"></i></span>
                <strong>{{ item.name }}</strong>
                <p v-if="item.description">{{ item.description }}</p>
            </span>
          </label>
          <div class="form-condition-container" v-if="inputValue == item.id"><slot :name="item.slot"></slot></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormCondition',
  props: ['value', 'label', 'hint', 'name', 'description', 'ident', 'default', 'options', 'callback', 'required', 'disabled'],
  data: function () {
    return {
      inputValue: null,
      requiredForm: false
    }
  },
  created: function () {
    this.inputValue = this.value
  },
  methods: {
    change: function (e) {
      if (e.target.checked) {
        this.internalValue = e.target.value;
        this.$emit('input', this.internalValue);
      }
    },
  },
  watch: {
    value(newVal) {
      this.inputValue = newVal;
    },
    inputValue(newVal) {
      this.$emit('input', newVal);
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/form/Condition.vue